export const blockIconsTransportationTurnRightNew = (
	<span className='material-symbols-outlined'>turn_right</span>
);
